import { FEATURE_SPECIAL_TEMPLATES, FEATURE_SPECIAL_RULES } from './env.js';

/**
 * Feature Flags Configuration
 * 
 * Punto único de verdad para feature flags de la aplicación.
 * Lee variables de entorno y proporciona defaults seguros.
 */

/**
 * Parsea un string de variable de entorno a boolean
 * @param {string|undefined} value - Valor de la env var
 * @param {boolean} defaultValue - Valor por defecto si no está definida
 * @returns {boolean}
 * 
 * Ejemplos:
 * parseEnvBoolean("true") → true
 * parseEnvBoolean("TRUE") → true  
 * parseEnvBoolean("false") → false
 * parseEnvBoolean("0") → false
 * parseEnvBoolean(undefined) → false (default)
 */
const parseEnvBoolean = (value, defaultValue = false) => {
    // Si la variable no está definida, usar el valor por defecto
    if (value === undefined || value === null) {
        return defaultValue;
    }

    // Convertir a string y comparar (case-insensitive)
    // Solo el string "true" se considera verdadero
    // Cualquier otro valor ("false", "0", "no", etc.) es falso
    const stringValue = String(value).toLowerCase();

    if (stringValue === 'true') {
        return true;
    } else {
        return false;
    }
};

/**
 * Feature flags disponibles en la aplicación
 */
const features = {
    /**
     * Special Templates (Birthday & Anniversary)
     * Controla la visibilidad del feature de plantillas especiales
     * 
     * Env var: REACT_APP_FEATURE_SPECIAL_TEMPLATES
     * Default: false (feature oculto)
     */
    specialTemplatesEnabled: parseEnvBoolean(
        FEATURE_SPECIAL_TEMPLATES,
        false
    ),
    /**
     * Special Rules
     * Controla la visibilidad del feature de reglas especiales
     * 
     * Env var: REACT_APP_FEATURE_SPECIAL_RULES
     * Default: false (feature oculto)
     */
    specialRulesEnabled: parseEnvBoolean(
        FEATURE_SPECIAL_RULES,
        true
    ),
};

// Logging en desarrollo para debugging
if (process.env.NODE_ENV === 'development') {
    console.log('[Feature Flags]', features);
}

export default features;
